import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { fiverr_limited_edition_logo } from '@fiverr-private/fit/icons/logos';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../../shared/SafePureComponent';

import './style.scss';

const LimitedEditionBanner = () => (
    <div className="limited-edition-banner">
        <div className="header">
            <i><I18n k="gig_page_perseus.limited_edition.banner.title"/></i>
            <Icon size={32}>{fiverr_limited_edition_logo}</Icon>
        </div>
        <div className="text-wrapper">
            <p><I18n k="gig_page_perseus.limited_edition.banner.submit_your_entry"/></p>
            <p className="info"><I18n k="gig_page_perseus.limited_edition.banner.info" parseMarkup/></p>
        </div>
    </div>
);

export { LimitedEditionBanner };
export default SafePureComponent(LimitedEditionBanner);
